import { useFormContext, useWatch } from 'react-hook-form';
import { Settings } from 'luxon';
import { JxtEventFormRange } from '@jooxter/ui';
import { ResourceTypeDtoMetaTypeEnum } from '@jooxter/api';
import { IBookingForm } from '@jooxter/utils';
import { JxtBookingQuickSlotsField } from '../JxtBookingQuickSlotsField';
import { IJxtBookingScheduleField } from './types';

/** Start/end range plus the quick slots the user can pick instead of typing hours. */
export const JxtBookingScheduleField = ({
  schema,
  resourceConfiguration,
  bookingToEdit,
  isStartLocked,
}: IJxtBookingScheduleField) => {
  const { control } = useFormContext<IBookingForm>();
  const watchResource = useWatch({ control, name: 'resource' });
  const resourceTimezone = watchResource?.timezone ? watchResource.timezone : Settings.defaultZone.name;

  return (
    <>
      <JxtEventFormRange
        sameDay={resourceConfiguration?.metaType !== ResourceTypeDtoMetaTypeEnum.Vehicle}
        timezone={resourceTimezone}
        isEditing={!!bookingToEdit}
        startDisabled={isStartLocked}
      />
      {/* A quick slot sets the start too, so none is offered - nor fetched - while the start is locked. */}
      {!isStartLocked && (
        <JxtBookingQuickSlotsField
          schema={schema}
          resourceConfiguration={resourceConfiguration}
          bookingToEdit={bookingToEdit}
        />
      )}
    </>
  );
};

export default JxtBookingScheduleField;
